"use client";
import {createContext, ReactNode, useContext, useState} from "react";

interface ModalContextType {
    isOpen: boolean;
    openModal: (isCheckoutFlow?: boolean) => void;
    closeModal: () => void;
    isRegistration: boolean;
    setIsRegistration: (value: boolean) => void;
    isCheckoutFlow: boolean;
    setIsCheckoutFlow: (value: boolean) => void;
    likedPosts: any;
    addLike: (value:any) => void;
    removeLike: (value:any) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalLoginProvider({children}: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isRegistration, setIsRegistration] = useState(false);
    const [isCheckoutFlow, setIsCheckoutFlow] = useState(false);
    const likes = getStorage();
    const [likedPosts, setLikedPosts] = useState<any>(likes);

    const openModal = (isCheckout = false) => {
        setIsCheckoutFlow(isCheckout);
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
        setIsCheckoutFlow(false);
    };

    function addLike(id: number) {
        const updatedLikes = Array.from(new Set([...likedPosts, id]));
        setLikedPosts(updatedLikes);
        saveStorage(updatedLikes);
    }


    function removeLike(id:number){
        const newLikes = likedPosts.filter((like:number) => like !== id);
        setLikedPosts(newLikes);
        saveStorage(newLikes);
    }

    return (
        <ModalContext.Provider value={{isOpen, openModal, closeModal, isRegistration, setIsRegistration, isCheckoutFlow, setIsCheckoutFlow, likedPosts, addLike, removeLike}}>
            {children}
        </ModalContext.Provider>
    );
}

export function useModal() {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
}

function getStorage() {
    if (typeof localStorage !== "undefined") {
        let value = localStorage.getItem("likedPosts");
        value = value ? JSON.parse(value) : [];
        return value;
    } else {
        return [];
    }
}


function saveStorage(value:any){
    localStorage.setItem("likedPosts", JSON.stringify(value));
}
